<template lang="html">
  <section>
    <div style="padding: 4rem 0;">

      <h3 style="text-align: center; margin-bottom: 1rem;">Født 12.05.1994</h3>

      <div class="timeline">
        <div class="timeline-item" v-for="entry in events">
          <div :is="entry.type" :entry="entry" v-in-viewport="'in-viewport'" @imageslider="setImages"></div>
        </div>
      </div>

    </div>

    <image-slider :items="imageSlider" v-if="imageSlider" @close="imageSlider = null">
    </image-slider>
  </section>
</template>

<script>
import InViewport from "../directives/in-viewport";
import { Workplace, Project, App } from "./types";
import ImageSlider from "./imageslider.vue";

export default {
  data() {
    return {
      imageSlider: null,
      events: [
        {
          type: "workplace",
          title: "Utdannelse Softwareutvikler",
          company: "GBS",
          link: "https://www.gbssg.ch/",
          location: "Sveits",
          content:
            "4 årig utdannelse som softwareutvikler i St. Gallen, Sveits",
          date: [new Date(2009, 7, 1), new Date(2013, 7, 1)]
        },
        {
          type: "workplace",
          title: "Softwareutvikler",
          company: "Softproject",
          location: "Sveits",
          link: "http://www.softproject.ch/",
          content:
            "Vidreutvikling og drift (C#) av software for transportbransjen. ",
          date: [new Date(2009, 7, 1), new Date(2013, 7, 1)]
        },
        {
          type: "workplace",
          title: "Webutvikler / Designer",
          company: "Horze",
          location: "Norge, Oslo",
          link: "https://www.horze.no/",
          content:
            "Utvikling av widgets, grafisk innhold & kampanjer for nettbutikk.",
          date: [new Date(2013, 7, 1), new Date(2014, 3, 1)]
        },
        {
          type: "workplace",
          title: "Webutvikler / Designer",
          company: "Infotjenester",
          location: "Norge, Sarpsborg",
          link: "https://infotjenester.no",
          content:
            "Utvikling av widgets, grafisk innhold & systemer. (Node, MongoDB, Vue, etc.)",
          date: [new Date(2014, 3, 1), new Date(2017, 3, 1)]
        },
        {
          type: "app",
          title: "Miniguide",
          ios: "https://itunes.apple.com/no/app/miniguide/id589463558",
          android:
            "https://play.google.com/store/apps/details?id=no.infotjenester.miniguiden",
          content:
            "Få tilgang til statens satser fra hvor som helst. Både aktuelle og historiske satser."
        },
        {
          type: "project",
          title: "Direkteplatform",
          link: "https://direkte.infotjenester.no",
          content:
            "Platform for livestreaming av kurs/webinarer med fildeling & chat, etc."
        },
        {
          type: "project",
          title: "Quizplatform",
          images: [
            "/projects/quiz/1.png",
            "/projects/quiz/2.png",
            "/projects/quiz/3.png",
            "/projects/quiz/4.png",
            "/projects/quiz/5.png"
          ],
          content:
            "Verktøy for opprettelse av quizzer & spørreundersøkelser, analyse & enkel embedding."
        },
        {
          type: "project",
          title: "Gamificationplatform",
          images: [
            "/projects/gamification/1.png",
            "/projects/gamification/2.png",
            "/projects/gamification/3.png",
            "/projects/gamification/4.png"
          ],
          content:
            "Platform for økt engasjement. Gjør det mulig å spillifisere tjenester på en enkel måte."
        },
        {
          type: "workplace",
          title: "Webutvikler / Designer",
          company: "Elder",
          location: "Norge, Sarpsborg",
          link: "https://elder.no",
          content:
            "Co-Founder, Utvikling av webbaserte systemer, apper, nettsider, nettbutikker.",
          date: [new Date(2017, 3, 1)]
        },
        {
          type: "project",
          title: "Svippt",
          link: "https://www.svippt.com/home",
          content:
            "Task Management System. Verktøy som forenkler arbeidshverdagen."
        },
        {
          type: "app",
          title: "Svippt",
          ios: "https://itunes.apple.com/no/app/svippt/id1245075105",
          android:
            "https://play.google.com/store/apps/details?id=com.elder.svippt",
          content:
            "Gjennomfør oppgaver raskt og effektivt. Samarbeid med andre og få ting gjort."
        },
        {
          type: "project",
          title: "Smud",
          images: [
            "/projects/smud/logo.svg",
            "/projects/smud/2.png",
            "/projects/smud/3.png",
            "/projects/smud/4.png"
          ],
          content:
            "Ressursplanlegging & bemanning på en enkel og effektiv måte."
        }
      ]
    };
  },
  methods: {
    setImages(images) {
      this.imageSlider = images;
    }
  },
  components: {
    Workplace,
    Project,
    App,
    ImageSlider
  },
  directives: {
    InViewport
  }
};
</script>

<style scoped lang="scss">
@import "../styles/base/_colors";

section {
  overflow: hidden;
  background: rgba($primary, 0.1);
}
</style>
